import { headerFontFamily } from "styles/theme";

const coral = "#C0533F";
const coralDark = "#A8412F";
const coralSurface = "#F8E4DE";

const styles = {
  container: {
    border: "1px solid #F0D7CF",
    background:
      "linear-gradient(180deg, #FDF4F1 0%, #FCF7F4 60%, #FBF9F7 100%)",
  },
  iconBox: {
    position: "relative",
    backgroundColor: coralSurface,
    color: coral,
    fontSize: 20,
  },
  iconDot: {
    position: "absolute",
    top: -3,
    right: -3,
    width: 14,
    height: 14,
    borderRadius: "50%",
    backgroundColor: coral,
    border: "2px solid #FDF4F1",
    animation: "actionItemPulse 1.8s ease-in-out infinite",
    "@keyframes actionItemPulse": {
      "0%": { boxShadow: `0 0 0 0 ${coral}66` },
      "70%": { boxShadow: `0 0 0 8px ${coral}00` },
      "100%": { boxShadow: `0 0 0 0 ${coral}00` },
    },
  },
  todayPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    px: "10px",
    py: "4px",
    borderRadius: "999px",
    backgroundColor: coral,
    color: "#fff",
    fontFamily: headerFontFamily,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    whiteSpace: "nowrap",
    animation: "actionItemPillPulse 1.8s ease-in-out infinite",
    "@keyframes actionItemPillPulse": {
      "0%": { boxShadow: `0 0 0 0 ${coral}59` },
      "70%": { boxShadow: `0 0 0 10px ${coral}00` },
      "100%": { boxShadow: `0 0 0 0 ${coral}00` },
    },
  },
  todayCount: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 16,
    height: 16,
    px: 0.5,
    borderRadius: "999px",
    backgroundColor: "rgba(255,255,255,0.22)",
    fontSize: 11,
  },
  subheader: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  subheaderDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: coral,
    flexShrink: 0,
  },
  subheaderText: {
    fontFamily: headerFontFamily,
    fontSize: 15,
    color: coralDark,
    "& b": { fontWeight: 700 },
  },
  list: {
    mt: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  item: {
    position: "relative",
    p: 2,
    borderRadius: 3,
    backgroundColor: "#fff",
    border: "1px solid",
    borderColor: "#EFE6DE",
    cursor: "pointer",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      borderColor: "#E2D2C8",
      boxShadow: "0 2px 10px rgba(192,83,63,0.08)",
    },
    "&:hover .action-item-archive": { opacity: 1 },
  },
  itemMain: {
    display: "flex",
    gap: 1.5,
    alignItems: "flex-start",
  },
  avatar: (active: boolean) => ({
    width: 44,
    height: 44,
    flexShrink: 0,
    fontFamily: headerFontFamily,
    fontSize: 16,
    fontWeight: 700,
    backgroundColor: active ? coralSurface : "#F7F6F0",
    color: active ? coral : "primary.main",
    border: active ? "none" : "1px solid #E5E0D6",
  }),
  itemContent: {
    flex: 1,
    minWidth: 0,
  },
  itemTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
  },
  itemTitleGroup: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0,
  },
  brandName: {
    fontFamily: headerFontFamily,
    fontSize: 16,
    fontWeight: 700,
    color: "primary.main",
  },
  msgChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    px: 0.75,
    py: 0.25,
    borderRadius: 1.5,
    backgroundColor: "#F4F2EC",
    color: "#7A8077",
    fontSize: 12,
    whiteSpace: "nowrap",
    "& i": { fontSize: 11 },
  },
  statusGroup: {
    display: "flex",
    alignItems: "center",
    gap: 0.75,
    flexShrink: 0,
  },
  status: (active: boolean) => ({
    fontSize: 14,
    fontWeight: active ? 600 : 400,
    color: active ? coral : "#7A8077",
    whiteSpace: "nowrap",
  }),
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: coral,
  },
  snippet: {
    mt: 0.75,
    fontSize: 14,
    color: "#4F5A52",
    lineHeight: 1.4,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    WebkitLineClamp: 2,
  },
  archive: {
    opacity: 0,
    transition: "opacity 0.15s ease",
    color: "#C4BEB4",
    fontSize: 13,
    width: 22,
    height: 22,
    position: "absolute",
    top: 8,
    right: 8,
  },
};

export default styles;
